const isDev = () => process.env.REACT_APP_ENV === 'development';

export default isDev;
